const actions = {
  LOAD_CURRENT_EDITING_MODULE({ commit }, payload) {
    // Your API calls need to be made here (actually, no)
    commit("SET_CURRENT_EDITING_MODULE", payload)
  },
  LOAD_CURRENT_COURSES_EDITING_STATE({ commit }, editState) {
    commit("SET_CURRENT_COURSES_EDITING_STATE", editState)
  },
  UPDATE_MODULE_ID({ commit }, moduleID) {
    commit("UPDATE_MODULE_ID", moduleID)
  },
  UPDATE_EDITING_TOPIC({ commit }, topicID) {
    commit("UPDATE_EDITING_TOPIC", topicID)
  },
  SET_CURRENT_TAG_LIST({ commit }, tagList) {
    commit("UPDATE_CURRENT_TAG_LIST", tagList)
  },
  SET_ORIGINAL_TAG_LIST({ commit }, tagList) {
    commit("UPDATE_ORIGINAL_TAG_LIST", tagList)
  },
  SET_ADDED_TAG_LIST({ commit }, tagList) {
    commit("UPDATE_ADDED_TAG_LIST", tagList)
  },
  SET_DELETED_TAG_LIST({ commit }, tagList) {
    commit("UPDATE_DELETED_TAG_LIST", tagList)
  },
  SET_QUESTION_STITCHER_LIST({ commit }, questionStitcherList) {
    commit("UPDATE_QUESTION_STITCHER_LIST", questionStitcherList)
  },
  SET_MEGA_JSON({ commit }, megaJSON) {
    commit("UPDATE_MEGA_JSON", megaJSON)
  },
  SET_CURRENT_EDITING_READING_OBJECT({ commit }, readingObj) {
    commit("UPDATE_CURRENT_EDITING_READING_OBJECT", readingObj)
  },
  SET_EDITING_QUESTION({ commit }, questionObj) {
    commit("UPDATE_EDITING_QUESTION", questionObj)
  },
}

export default actions
